/**
 * Normalizes a name by trimming leading and trailing whitespace,
 * converting it to lowercase, and removing characters other than
 * ASCII letters, whitespace, apostrophes, and hyphens.
 *
 * @param {string} name - The name to normalize.
 * @returns {string} The normalized name.
 */
export function normalizeName(name) {
	return (name || '').trim().toLowerCase().replace(/[^a-z\s'-]/g, '');
}
